import instance from "@/services/api";

export const closingDocumentsAPI = {
  // Список закрывающих документов (К2СВ, АВР, М19)
  // params: doc_type, project_id, status, resident_id, project_type_id,
  //         contractor_id, block_name, entrance, level_num
  async getDocuments(params = {}) {
    return await instance()
      .get(`/project/documents/closing/read/`, { params })
      .then((res) => res?.data);
  },

  // Создать АВР из существующего КС2В (на бэке вместе с 3КС)
  async createFollowupFromK2sv(floor_map_document_id) {
    return await instance()
      .post(`/project/documents/manual/create_followup_from_k2sv/`, { floor_map_document_id })
      .then((res) => res?.data);
  },

  /** Бумажный скан BUH_AVR */
  async uploadBuhAvrManualSign({ floor_map_document_id, file, sign_date, params = {} }) {
    const form = new FormData();
    form.append("file", file);
    form.append("floor_map_document_id", String(floor_map_document_id));
    form.append("sign_date", sign_date);
    return await instance()
      .post(`/project/documents/manual/sign-upload/`, form, {
        params,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res?.data);
  },

  // WBS дерево для М19 перерасход (все проекты ЖК с данным типом)
  // Необязательный query sbs_sklad_id — сумма резерва в ответе по этому складу списания
  async getM19OverWbs(resident_id, project_type_id, sbs_sklad_id) {
    const params = { resident_id, project_type_id };
    if (sbs_sklad_id != null && sbs_sklad_id !== "") {
      params.sbs_sklad_id = sbs_sklad_id;
    }
    return await instance()
      .get(`/project/documents/m19over/wbs/read/`, { params })
      .then((res) => res?.data);
  },

  async getM19OverSkladOptions(project_id) {
    const params = { project_id };
    return await instance()
      .get(`/project/documents/m19over/sklad-options/read/`, { params })
      .then((res) => res?.data);
  },

  async getM19PriceChanges(floor_map_document_id) {
    return await instance()
      .get(`/project/documents/m19over/price-changes/read/`, {
        params: { floor_map_document_id },
      })
      .then((res) => res?.data);
  },

  async previewM19OverDelete(floor_map_document_id) {
    return await instance()
      .get(`/project/documents/m19over/delete/preview/`, {
        params: { floor_map_document_id },
      })
      .then((res) => res?.data);
  },

  async deleteM19Over(material_overuse_id) {
    return await instance()
      .post(`/project/documents/m19over/delete/`, { material_overuse_id })
      .then((res) => res?.data);
  },

  async previewM19OverWarehouseBalances(project_id, material_ids, sbs_sklad_id) {
    return await instance()
      .post(`/project/documents/m19over/warehouse-balances/preview/`, {
        project_id,
        material_ids,
        sbs_sklad_id,
      })
      .then((res) => res?.data);
  },

  // Создать М19 перерасход
  async createM19Over(project_id, materials, sbs_sklad_id) {
    return await instance()
      .post(`/project/documents/m19over/create/`, { project_id, materials, sbs_sklad_id })
      .then((res) => res?.data);
  },

  // Предпросмотр М19 (PDF)
  async previewM19Over(project_id, materials) {
    return await instance()
      .post(`/project/documents/m19over/preview/`, { project_id, materials }, {
        responseType: 'blob',
      })
      .then((res) => res);
  },

  // Справочник ЖК
  async getResidents() {
    return await instance()
      .get(`/project/resident/read/`)
      .then((res) => res?.data);
  },

  // Каскадные фильтры: контрагенты, блоки (по подъезду), этажи
  // params: resident_id, project_type_id, contractor_id, block_name, entrance
  async getCascade(params = {}) {
    return await instance()
      .get(`/project/documents/closing/cascade/read/`, { params })
      .then((res) => res?.data);
  },

  /** JSON превью формы 2В для существующего КС‑2В (как данные Excel). */
  async getKc2bForm2vPreview(floor_map_document_id) {
    return await instance()
      .get(`/project/documents/closing/kc2b/form2v/preview/`, {
        params: { floor_map_document_id },
      })
      .then((res) => res?.data);
  },

  /** JSON превью АВР 3‑2. */
  async getAvr32Preview(floor_map_document_id) {
    return await instance()
      .get(`/project/documents/closing/avr32/preview/`, {
        params: { floor_map_document_id },
      })
      .then((res) => res?.data);
  },

  /** JSON превью М‑19 перерасхода по сохранённому документу. */
  async getM19OverDocumentPreview(floor_map_document_id) {
    return await instance()
      .get(`/project/documents/closing/m19over/document/preview/`, {
        params: { floor_map_document_id },
      })
      .then((res) => res?.data);
  },

  async downloadKc2bForm2vExcel(params) {
    return await instance(true, null, { showToast: false, throwError: true }).get(
      `/project/documents/closing/kc2b/form2v/excel/`,
      { params, responseType: "blob" },
    );
  },

  async downloadAvr32Excel(params) {
    return await instance(true, null, { showToast: false, throwError: true }).get(
      `/project/documents/closing/avr32/excel/`,
      { params, responseType: "blob" },
    );
  },

  async downloadM19OverDocumentExcel(params) {
    return await instance(true, null, { showToast: false, throwError: true }).get(
      `/project/documents/closing/m19over/document/excel/`,
      { params, responseType: "blob" },
    );
  },

};
